import React, { useEffect, useRef, useState } from 'react'
import { CloseButton, Flex, Input } from '@mantine/core'
import { IconSearch } from '@tabler/icons-react'
import { color } from 'src/variable/constant'

function CustomClearInput({
	value,
	onChange,
	placeholder,
	sx = {},
	onEnterPress,
	...props
}: any) {
	const ref = useRef<HTMLInputElement>(null)
	const isComposingRef = useRef(false)
	const lastEnterAtRef = useRef(0)
	const [draftValue, setDraftValue] = useState(value ?? '')
	const { onKeyDown, ...inputProps } = props

	useEffect(() => {
		if (!isComposingRef.current) {
			setDraftValue(value ?? '')
		}
	}, [value])

	const handleEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key !== 'Enter' || isComposingRef.current || !onEnterPress) {
			return
		}

		event.preventDefault()
		event.stopPropagation()

		const now = Date.now()
		if (now - lastEnterAtRef.current < 300) {
			return
		}
		lastEnterAtRef.current = now

		onEnterPress()
	}

	return (
		<Input
			ref={ref}
			placeholder={placeholder ? placeholder : ''}
			value={draftValue}
			autoComplete="off"
			onChange={(event) => {
				const nextValue = event.currentTarget.value
				setDraftValue(nextValue)

				if (!isComposingRef.current) {
					onChange(nextValue)
				}
			}}
			onCompositionStart={() => {
				isComposingRef.current = true
			}}
			onCompositionEnd={(event) => {
				isComposingRef.current = false
				const nextValue = event.currentTarget.value
				setDraftValue(nextValue)
				onChange(nextValue)
			}}
			onKeyDown={(event) => {
				handleEnter(event)
				onKeyDown?.(event)
			}}
			sx={{
				minWidth: 240,
				height: 36,
				input: {
					borderRadius: 8,
					borderColor: '#dbe5dd',
					background: '#ffffff',
					fontWeight: 500,
					':focus': {
						borderColor: color.CmsPrimary,
					},
				},
				...sx,
			}}
			{...inputProps}
			rightSection={
				draftValue ? (
					<CloseButton
						aria-label="Clear input"
						onClick={() => {
							isComposingRef.current = false
							setDraftValue('')
							onChange('')
							ref.current?.focus()
						}}
						style={{ display: draftValue ? undefined : 'none' }}
					/>
				) : (
					<Flex>
						<IconSearch color={color.Black} />
					</Flex>
				)
			}
		/>
	)
}

export default React.memo(CustomClearInput)
